import * as React from 'react'
import { Grid } from '@material-ui/core'
import { CellInfo, SortingRule } from 'react-table'
import { c, t } from 'ttag'
import { polyfill } from 'seamless-scroll-polyfill'
import { ReactComponent as IconGoalLine } from '../../assets/v2/icons/icon-goal-line.svg'
import { ReactComponent as IconGoalLineInverse } from '../../assets/v2/icons/icon-goal-line-inverse.svg'
import { ReactComponent as IconExport } from '../../assets/v2/icons/icon-export.svg'
import { ReactComponent as IconDownload } from '../../assets/v3/icons/ranking/download.svg'
import { ReactComponent as IconFind } from '../../assets/v3/icons/ranking/find.svg'
import {
  getActivityProgressCaloriesComparator,
  getActivityProgressMinutesComparator,
  getActivityProgressPercentageComparator,
  getActivityProgressPersistenceComparator,
  getActivityProgressStepsComparator,
  getCountryActivityProgressCaloriesComparator,
  getCountryActivityProgressMinutesComparator,
  getCountryActivityProgressPercentageComparator,
  getCountryActivityProgressPersistenceComparator,
  getCountryActivityProgressStepsComparator,
  getDivisionActivityProgressCaloriesComparator,
  getDivisionActivityProgressMinutesComparator,
  getDivisionActivityProgressPercentageComparator,
  getDivisionActivityProgressPersistenceComparator,
  getDivisionActivityProgressStepsComparator,
} from '../../common/helpers/comparators'
import { getFullName } from '../../common/helpers/translations'
import { ProgressCell } from '../Table/components/ProgressCell/ProgressCell'
import { Table } from '../Table/Table'
import {
  ActivityProgress,
  CompanyCountriesDto,
  CompanyId,
  CountryActivityProgress,
  CustomType,
  DivisionActivityProgress,
  DivisionDto,
  DivisionId,
  GoalId,
  GoalWithProgress,
  GroupView,
  ProgressType,
  Role,
  UserCompanyDto,
  UserProfileDto,
} from '../../services/api.types'
import YumButton from '../../components/YumButton/YumButton'
import { YumActivityFilter } from '../YumActivityFilter/YumActivityFilter'
import { countryToFlag, countryWithFlag } from '../YumCountrySelect/YumCountrySelect'
import { ActivityView } from '../../views/Activity/store/ActivityReducer'
import Typography from '@material-ui/core/Typography'
import BlueTooltip from '../../components/YumBlueTooltip/YumBlueTooltip'
import Box from '@material-ui/core/Box'
import YumAvgSumFilter from '../YumAvgSumFilter/YumAvgSumFilter'
import { isNative } from '../../common/helpers/isNative'
import { isCollectiveType, isCustomType, isPersistenceType } from '../../common/helpers/challenges'
import YumChatButton from '../../views/ChallengeChat/components/YumChatButton/YumChatButton'
import { isRtl } from '../../i18nInit'
import YumLeaderboardTabs from '../YumLeaderboardTabs/YumLeaderboardTabs'
import YumLeaderboardTab from '../YumLeaderboardTabs/YumLeaderboardTab/YumLeaderboardTab'
import moment from 'moment'
import { convertUTCToLocalDate } from '../../common/helpers/date'
import { IJoinGoalPayload } from '../../views/Activity/store/ActivitySagas'
import { refreshChallengeResults } from '../../views/Progress/store/ProgressActions'

// @ts-ignore
polyfill()

const ROWS_VISIBLE_BY_DEFAULT = isNative() ? 100 : 1000

export interface IStateProps {
  hasRoleInCompany(companyId: CompanyId, role: Role): boolean
  goalDto: GoalWithProgress
  userDto: UserProfileDto
  userCompanies: UserCompanyDto[]
  activityProgress: ActivityProgress[]
  divisionActivityProgress: DivisionActivityProgress[]
  countryActivityProgress: CountryActivityProgress[]
  activityPeriodPercentage: number
  activityProgressLoading: boolean
  countries: CompanyCountriesDto[]
  divisions: DivisionDto[]
  activityFilter: {
    countries: string[]
    divisionIds: DivisionId[]
  }
  userIsInActivityList: boolean
  activityView: ActivityView
  groupView: GroupView
  groupSum: boolean
  joinInProgress: boolean

  token: string | undefined
  isNewLayout?: boolean
}

export interface IDispatchProps {
  getCurrentGoalActivityList(payload?: {
    goalId: GoalId
    divisionId: DivisionId
    activityFilter?: {
      countries: string[]
      divisionIds: DivisionId[]
    }
    activityView?: ActivityView
    groupView?: GroupView
    groupSum?: boolean
    token: string | undefined
  }): void
  getCurrentGoalActivityListClear(payload?: { goalId: GoalId; updateGroupView?: boolean }): void
  getCurrentGoalExport(payload?: any): void
  joinGoal(payload: IJoinGoalPayload): void
}

type IActivityProps = IStateProps & IDispatchProps

export class YumGoalRanking extends React.PureComponent<IActivityProps> {
  state = {
    isTotalProjectedPercentageVisible: true,
    defaultActivityFilter: {
      countries: [],
      divisionIds: [],
    },
    visibleItems: ROWS_VISIBLE_BY_DEFAULT,
    myPosition: 0,
    divisionId: null as DivisionId,
  }

  componentDidUpdate(prevProps: Readonly<IActivityProps>, prevState: Readonly<{}>, snapshot?: any) {
    const { goalDto, userCompanies } = this.props
    const { companyId } = goalDto
    const { divisionId } = userCompanies.find((uc) => uc.companyId === companyId) || { divisionId: '', country: '' }
    this.setState({ divisionId })
  }

  timerId: any
  componentDidMount(): void {
    this.updateData()

    /*setTimeout(() => {
      document.body.classList.add('show-back-btn')
    }, 0)*/

    // For Leaderboard view, auto-refresh in every 5 minutes.
    if (this.props.token) {
      this.timerId = setInterval(() => {
        this.updateData()
      }, 300000)
    }
  }

  updateData = () => {
    const {
      goalDto: { id: goalId, companyId, progressType, hidePeopleTab, hideGroupsTab, hideCountriesTab },
      token,
    } = this.props
    const { divisionId } = this.state
    const activityFilter = this.props.activityFilter || this.state.defaultActivityFilter
    const activityView = this.getActivityView(this.props.activityView, hidePeopleTab, hideGroupsTab, hideCountriesTab)
    const groupView =
      !this.props.countries || !this.props.countries.length
        ? GroupView.COUNTRIES_MERGED
        : this.props.groupView
        ? this.props.groupView
        : GroupView.COUNTRIES_MERGED
    const isCollectiveChallenge = isCollectiveType(progressType)
    const groupSum =
      this.props.groupSum !== undefined && this.props.groupSum !== null ? this.props.groupSum : isCollectiveChallenge

    // TODO: Load country or what ever...
    this.props.getCurrentGoalActivityList({
      goalId,
      divisionId,
      activityFilter,
      activityView,
      groupView,
      groupSum,
      token,
    })
  }

  componentWillUnmount(): void {
    //document.body.classList.remove('show-back-btn')
    if (this.timerId) clearInterval(this.timerId)
  }

  handleTabChange = (event: React.ChangeEvent<{}>, activityView: ActivityView) => {
    const {
      goalDto: { id: goalId },
      token,
    } = this.props
    const { divisionId } = this.state
    const activityFilter = this.props.activityFilter || this.state.defaultActivityFilter
    this.props.getCurrentGoalActivityList({ goalId, divisionId, activityFilter, activityView, token })
  }

  setActivityFilter = (activityFilter: any) => {
    const {
      goalDto: { id: goalId },
      activityView,
      token,
    } = this.props
    const { divisionId } = this.state
    this.setState({ activityFilter }, () => {
      this.props.getCurrentGoalActivityListClear({ goalId })
      this.props.getCurrentGoalActivityList({ goalId, divisionId, activityFilter, activityView, token })
    })
  }

  setGroupView = (groupView: GroupView) => {
    const {
      goalDto: { id: goalId },
      activityView,
      token,
    } = this.props
    const { divisionId } = this.state
    this.props.getCurrentGoalActivityListClear({ goalId, updateGroupView: true })
    this.props.getCurrentGoalActivityList({ goalId, divisionId, groupView, activityView, token })
  }

  setGroupSum = (groupSum: boolean) => {
    const {
      goalDto: { id: goalId },
      token,
    } = this.props
    const { divisionId } = this.state
    this.props.getCurrentGoalActivityListClear({ goalId, updateGroupView: true })
    this.props.getCurrentGoalActivityList({ goalId, divisionId, groupSum, token })
  }

  findMe = (totalItems: number, selfPosition: number) => () => {
    const {
      goalDto: { id: goalId },
      activityView,
      userDto,
    } = this.props

    // If "me" is not visible, load at least that many items
    if (this.state.visibleItems < selfPosition) {
      const newVisibleItems =
        Math.ceil(selfPosition / ROWS_VISIBLE_BY_DEFAULT) * ROWS_VISIBLE_BY_DEFAULT + ROWS_VISIBLE_BY_DEFAULT
      //console.log(`We need to show at least ${newVisibleItems} items`)
      this.fetchMoreData(totalItems, newVisibleItems)()
    }

    setTimeout(() => {
      let compareId
      if (activityView === ActivityView.INDIVIDUAL) {
        compareId = userDto.userId
      } else if (activityView === ActivityView.GROUP) {
        // TODO: Get divisionId from new place
        //compareId = userDto.divisionId
      } else {
        compareId = userDto.country
      }

      const element = document.getElementById(String(goalId) + String(compareId))
      if (element) {
        if (isNative()) {
          const top = element.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 2
          document.getElementById('content')?.scrollTo({ top, behavior: 'smooth' })
        } else {
          element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
        }
      }
    }, 100)
  }

  joinGoal = () => {
    const { goalDto, joinGoal } = this.props

    const {
      goalDto: { id: goalId, companyId },
      activityView,
      token,
    } = this.props

    const { divisionId } = this.state
    const activityFilter = this.props.activityFilter || this.state.defaultActivityFilter

    const isPoints = goalDto.customType === CustomType.POINTS
    const pointsLogic = isPoints ? JSON.parse(goalDto.pointsLogic) : null
    const challengeStartDate = moment(convertUTCToLocalDate(new Date(goalDto.startDate)))
    const challengeEndDate = moment(convertUTCToLocalDate(new Date(goalDto.endDate)))

    joinGoal({
      goalId: goalDto.id,
      progressType: goalDto.progressType,
      customType: goalDto.customType,
      manualEntryEnabled: goalDto.manualEntryEnabled,

      // For refreshChallengeResults.
      isPoints,
      pointsLogic,
      startDateFormatted: challengeStartDate.locale('en').format('YYYY-MM-DD'),
      endDateFormatted: challengeEndDate.locale('en').format('YYYY-MM-DD'),
    })
  }

  handleSortedChange = (newSorted: SortingRule[]) => {
    const { id, desc } = newSorted[0]

    const isSortedByTotalPercentageDesc = id === 'totalPercentage' && desc
    const isSortedByRankAsc = id === 'rank' && !desc

    this.setState({ isTotalProjectedPercentageVisible: isSortedByTotalPercentageDesc || isSortedByRankAsc })
  }

  export = () => {
    const {
      goalDto: { id: goalId },
    } = this.props
    this.props.getCurrentGoalExport(goalId)
  }

  fetchMoreData = (totalItems: number, visibleItems?: number) => () => {
    if (this.state.visibleItems < totalItems) {
      const newVisibleItems = visibleItems || this.state.visibleItems + ROWS_VISIBLE_BY_DEFAULT
      //console.log(`fetchMoreData from ${this.state.visibleItems} to ${newVisibleItems}`)
      this.setState({ visibleItems: newVisibleItems })
    }
  }

  getActivityView = (
    activityView: ActivityView,
    hidePeopleTab: boolean,
    hideGroupsTab: boolean,
    hideCountriesTab: boolean,
  ) => {
    let defaultView = activityView || ActivityView.INDIVIDUAL
    if (defaultView === ActivityView.INDIVIDUAL && hidePeopleTab) defaultView = ActivityView.GROUP
    if (defaultView === ActivityView.GROUP && hideGroupsTab) defaultView = ActivityView.COUNTRY
    if (defaultView === ActivityView.COUNTRY && hideCountriesTab && !hidePeopleTab)
      defaultView = ActivityView.INDIVIDUAL
    if (defaultView === ActivityView.COUNTRY && hideCountriesTab && hidePeopleTab) defaultView = ActivityView.GROUP
    return defaultView
  }

  render() {
    const { isTotalProjectedPercentageVisible, visibleItems } = this.state
    const {
      goalDto,
      activityProgressLoading,
      userDto,
      userCompanies,
      activityFilter,
      groupView,
      hasRoleInCompany,
      isNewLayout,
    } = this.props
    const { userId } = userDto
    const {
      id: goalId,
      companyId,
      progressType,
      activityFormulaTarget,
      hidePeopleTab,
      hideGroupsTab,
      hideCountriesTab,
      chatEnabled,
      participating,
      customType,
      customUnit,
    } = goalDto

    if (!Object.values(ProgressType).includes(progressType)) {
      return <div className={'text-center'}>{t`Challenge type not supported. Please check for updates.`}</div>
    }

    const isAdmin = hasRoleInCompany(companyId, Role.ADMIN)
    const isUser = hasRoleInCompany(companyId, Role.USER)
    const divisions = this.props.divisions.filter((d) => d.companyId === companyId)

    const userCompany = userCompanies.find((uc) => uc.companyId === companyId) || { divisionId: '', country: '' }
    const { divisionId, country } = userCompany

    const companyCountries = this.props.countries.find((c) => c.companyId === companyId) || { countries: [] }
    const { countries } = companyCountries

    const activityView = this.getActivityView(this.props.activityView, hidePeopleTab, hideGroupsTab, hideCountriesTab)
    const isCollectiveChallenge = isCollectiveType(progressType)
    const groupSum =
      this.props.groupSum !== undefined && this.props.groupSum !== null ? this.props.groupSum : isCollectiveChallenge

    const isPersistenceChallenge = isPersistenceType(progressType)

    const isCustom = isCustomType(progressType)
    const isSteps = [ProgressType.STEPS, ProgressType.COLLECTIVE_STEPS].includes(progressType)
    const isCalories = [ProgressType.CALORIES, ProgressType.COLLECTIVE_CALORIES].includes(progressType)
    const isMinutes = [ProgressType.INTENSIVE_MINUTES, ProgressType.COLLECTIVE_INTENSIVE_MINUTES].includes(progressType)

    let activityProgress, activityProgressComparator
    if (activityView === ActivityView.GROUP) {
      activityProgress = this.props.divisionActivityProgress
      activityProgressComparator =
        isPersistenceChallenge || isCustom
          ? getDivisionActivityProgressPersistenceComparator
          : isSteps
          ? getDivisionActivityProgressStepsComparator
          : isCalories
          ? getDivisionActivityProgressCaloriesComparator
          : isMinutes
          ? getDivisionActivityProgressMinutesComparator
          : getDivisionActivityProgressPercentageComparator
    } else if (activityView === ActivityView.COUNTRY) {
      activityProgress = this.props.countryActivityProgress
      activityProgressComparator =
        isPersistenceChallenge || isCustom
          ? getCountryActivityProgressPersistenceComparator
          : isSteps
          ? getCountryActivityProgressStepsComparator
          : isCalories
          ? getCountryActivityProgressCaloriesComparator
          : isMinutes
          ? getCountryActivityProgressMinutesComparator
          : getCountryActivityProgressPercentageComparator
    } else {
      activityProgress = this.props.activityProgress
      activityProgressComparator =
        isPersistenceChallenge || isCustom
          ? getActivityProgressPersistenceComparator
          : isSteps
          ? getActivityProgressStepsComparator
          : isCalories
          ? getActivityProgressCaloriesComparator
          : isMinutes
          ? getActivityProgressMinutesComparator
          : getActivityProgressPercentageComparator
    }

    let selfPosition = 0
    //let prevRank = 0
    //let prevTotal = -1
    const activityProgressSorted = Object.entries(activityProgress || {}).sort(activityProgressComparator) || []
    const data = activityProgressSorted
      .map((i, index) => {
        if (!i || !i[1]) {
          return null
        }

        const { totalPercentage, stepsTotal } = i[1]

        let name, compareId, ofPeriodPassedPercentage, isSelf
        if (activityView === ActivityView.INDIVIDUAL) {
          const { firstName, lastName, email } = i[1]
          compareId = i[1].userId
          name = getFullName(firstName, lastName, email)
          isSelf = userId === compareId
          ofPeriodPassedPercentage = i[1].ofPeriodPassedPercentage
        } else if (activityView === ActivityView.GROUP) {
          name = i[1].divisionName
          compareId = i[1].divisionId
          ofPeriodPassedPercentage = this.props.activityPeriodPercentage

          if (this.props.groupView === GroupView.COUNTRIES_MERGED) {
            isSelf = divisionId === compareId
          } else {
            isSelf = divisionId === compareId && country === i[1].country
          }
        } else {
          compareId = i[1].country
          name = countryWithFlag(compareId)
          isSelf = country === compareId
          ofPeriodPassedPercentage = this.props.activityPeriodPercentage
        }

        if (isSelf) {
          //this.setState({ myPosition: index + 1 })
          selfPosition = index + 1
        }

        let target = 100

        // Needed for past goals.
        if (ofPeriodPassedPercentage === null) {
          if (i[1].endDate < new Date().getTime()) {
            ofPeriodPassedPercentage = target
          }
        }

        // Custom target.
        if (progressType === ProgressType.ALL && activityFormulaTarget && ofPeriodPassedPercentage !== null) {
          target = activityFormulaTarget
          ofPeriodPassedPercentage = Math.round(ofPeriodPassedPercentage * (target / 100))
        }

        // Prevent multiple green lines – side effect with 0%.
        /*if (ofPeriodPassedPercentage < 1 && i[1].startDate < new Date().getTime()) {
          ofPeriodPassedPercentage = 1
        }*/

        const isCompleted = totalPercentage >= target

        // Use regular indexing, not competitive ranking.
        const rank = index + 1
        /*const nextTotal =
          progressType === ProgressType.STEPS ? formatNullValues(stepsTotal) : formatNullValues(totalPercentage)
        const sameRankAsPrev = nextTotal === prevTotal
        const rank = sameRankAsPrev ? prevRank : index + 1
        prevTotal = nextTotal
        prevRank = rank*/

        const prevUser = activityProgressSorted.map((user) => user[1])[index - 1] || { totalPercentage: undefined }
        const nextUser = activityProgressSorted.map((user) => user[1])[index + 1] || { totalPercentage: undefined }

        let isSeparatorForAbove, isSeparatorForBelow
        if (
          !isCollectiveChallenge &&
          (ofPeriodPassedPercentage || ofPeriodPassedPercentage === 0) &&
          activityView === ActivityView.INDIVIDUAL
        ) {
          isSeparatorForAbove =
            isTotalProjectedPercentageVisible &&
            totalPercentage < ofPeriodPassedPercentage &&
            prevUser.totalPercentage === undefined

          isSeparatorForBelow =
            isTotalProjectedPercentageVisible &&
            totalPercentage >= ofPeriodPassedPercentage &&
            (!nextUser.totalPercentage || nextUser.totalPercentage < ofPeriodPassedPercentage)
        }

        // Prevent multiple green lines – side effect with 0%.
        if (isSeparatorForBelow && ofPeriodPassedPercentage === 0 /*&& i[1].startDate < new Date().getTime()*/) {
          isSeparatorForBelow = false
        }

        const alignRight = isCollectiveChallenge

        return {
          ...i[1],
          name,
          isCompleted,
          isSelf,
          isSeparatorForBelow,
          isSeparatorForAbove,
          rank,
          progressType,
          target,
          alignRight,
        }
      })
      .filter(Boolean)

    // We need the isBeforeSelf flag to prevent table line in the previous row.
    if (data.length) {
      data.some((element, index, array) => {
        if (element.isSelf && index > 0) {
          array[index - 1].isBeforeSelf = true
          return true
        }
        return false
      })
    }

    const isMciPeople =
      companyId === '88e7ce47-96ee-4679-b340-72ba58835e41' &&
      progressType === ProgressType.COLLECTIVE_CALORIES &&
      activityView === ActivityView.INDIVIDUAL

    const columns = [
      {
        className: Table.rankBEM(data.length),
        headerClassName: Table.rankBEM(data.length),
        Cell: ({ original: { rank } }: CellInfo) => <span>{rank + '.'}</span>,
        accessor: 'rank',
      },
      {
        Cell: ({ original }: CellInfo) => {
          if (activityView === ActivityView.INDIVIDUAL) {
            const goalIconStyles = original.isSeparatorForAbove
              ? { position: 'absolute', zIndex: 2, top: 2, left: '50%', marginLeft: -9 }
              : { position: 'absolute', zIndex: 2, bottom: -8, left: '50%', marginLeft: -9 }
            return (
              <>
                {original.isSeparatorForAbove || original.isSeparatorForBelow ? (
                  <BlueTooltip
                    title={t`Being above the line shows that you are on the track to complete the goal by the end of the period.`}
                    placement="top"
                    enterTouchDelay={50}
                    leaveTouchDelay={3000}
                    arrow
                    PopperProps={{
                      container: document.getElementById('content'),
                      disablePortal: true,
                    }}
                  >
                    <span style={goalIconStyles as object}>
                      {original.isSeparatorForBelow ? <IconGoalLine /> : <IconGoalLineInverse />}
                    </span>
                  </BlueTooltip>
                ) : (
                  ''
                )}
                <span>
                  <span
                    id={goalId + original.userId}
                    style={{
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      overflow: 'hidden',
                    }}
                  >
                    {original.name}
                  </span>
                  {original.country || original.divisionName ? (
                    <>
                      <br />
                      <small>
                        {!isMciPeople && original.country && this.props.countries && this.props.countries.length ? (
                          <span style={{ marginRight: 2, lineHeight: 1 }}>{countryToFlag(original.country)}</span>
                        ) : (
                          ''
                        )}
                        {original.divisionName}
                      </small>
                    </>
                  ) : (
                    ''
                  )}
                </span>
              </>
            )
          } else if (activityView === ActivityView.GROUP) {
            return (
              <>
                <span>
                  <span id={goalId + original.divisionId}>
                    {original.country && this.props.countries && this.props.countries.length ? (
                      <span style={{ marginRight: 2, lineHeight: 1 }}>{countryToFlag(original.country)}</span>
                    ) : (
                      ''
                    )}
                    {original.divisionName}
                  </span>
                  <br />
                  <small style={{ whiteSpace: 'nowrap' }}>
                    {t`Participants`}: {original.participants}
                  </small>
                </span>
              </>
            )
          } else {
            return (
              <>
                <span>
                  <span id={goalId + original.country}>{countryWithFlag(original.country)}</span>
                  <br />
                  <small style={{ whiteSpace: 'nowrap' }}>
                    {t`Participants`}: {original.participants}
                  </small>
                </span>
              </>
            )
          }
        },
        Header: t`Name`,
        accessor: 'name',
      },
      {
        Cell: ({
          original: {
            caloriesTotal,
            intensiveMinutesTotal,
            stepsTotal,
            totalPercentage,
            progressType,
            target,
            persistenceTotal,
            persistencePercentage,
            country,
          },
        }: CellInfo) => {
          if (isMciPeople) {
            return country && this.props.countries && this.props.countries.length ? countryToFlag(country) : ''
          } else {
            return (
              <ProgressCell
                caloriesTotal={caloriesTotal}
                intensiveMinutesTotal={intensiveMinutesTotal}
                stepsTotal={stepsTotal}
                progress={
                  isPersistenceChallenge
                    ? persistencePercentage
                    : isCollectiveChallenge
                    ? undefined
                    : parseInt(totalPercentage)
                }
                progressType={progressType}
                activityFormulaTarget={target}
                persistenceTotal={persistenceTotal}
                customType={customType}
                customUnit={customUnit}
              />
            )
          }
        },
        Header: t`Result`,
        accessor: 'totalPercentage',
      },
    ]

    let showFilterButton = false
    if (activityView === ActivityView.INDIVIDUAL) {
      showFilterButton = !!(((divisions && divisions.length) || (countries && countries.length)) && groupView)
    } else if (activityView === ActivityView.GROUP) {
      showFilterButton = !!(countries && countries.length && groupView)
    }

    // The filtering functionality was added in April 2020, hide tabs for older goals.
    let showTabs =
      goalDto.startDate >= 1585688400000 && ((divisions && divisions.length) || (countries && countries.length))

    // Tabs could be explicitly hidden.
    if ([hidePeopleTab, hideGroupsTab, hideCountriesTab].filter((v) => v).length >= 2) {
      showTabs = false
    }

    const participantsCount = goalDto.participantsCount ? ` (${goalDto.participantsCount})` : ''

    const visibleData = data.slice(0, visibleItems)
    const totalItems = data.length

    const isChatVisible = chatEnabled && (participating || isAdmin)
    const { firstName, lastName, email } = userDto
    const name = getFullName(firstName, lastName, email)

    //const isFutureOrActiveGoal = goalDto.endDate >= new Date().getTime()
    const isPresentOrFutureGoal = moment(convertUTCToLocalDate(new Date(goalDto.endDate))).isAfter(new Date())

    const header = (
      <Grid
        container={true}
        justifyContent="space-between"
        alignItems="center"
        style={{ minHeight: 30, marginBottom: isNewLayout ? '16px' : '10px' }}
        wrap="nowrap"
      >
        <Grid item style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Typography variant="caption" style={{ margin: 0, whiteSpace: 'nowrap' }}>
            {c('caption').t`Participants`}
            {participantsCount}
          </Typography>
        </Grid>

        <Grid item style={{ margin: isNewLayout ? 0 : '10px 0 0 0', flexShrink: 0 }}>
          {isNewLayout && !participating && isUser && isPresentOrFutureGoal ? (
            <YumButton
              size="medium"
              color="secondary"
              style={isRtl ? { marginRight: '10px' } : { marginLeft: '10px' }}
              onClick={this.joinGoal}
              disabled={this.props.joinInProgress}
            >
              {t`Join`}
            </YumButton>
          ) : (
            ''
          )}
          {!isNewLayout && isChatVisible ? (
            <YumChatButton
              userId={userId}
              goalId={goalId}
              name={name}
              connect={goalDto.participantsCount > 0 && goalDto.participantsCount < 1000}
            />
          ) : (
            ''
          )}
          {participating && activityView === ActivityView.INDIVIDUAL && this.props.userIsInActivityList ? (
            <YumButton
              size={isNewLayout ? 'medium' : 'small'}
              style={isRtl ? { marginRight: '8px' } : { marginLeft: '8px' }}
              onClick={this.findMe(totalItems, selfPosition)}
            >
              <IconFind />
              <span style={isRtl ? { marginRight: '4px' } : { marginLeft: '4px' }}>{t`Find me`}</span>
            </YumButton>
          ) : (
            ''
          )}
          {progressType !== ProgressType.ALL && activityView !== ActivityView.INDIVIDUAL ? (
            <YumAvgSumFilter groupSum={groupSum} setGroupSumFilter={this.setGroupSum} isNewLayout={isNewLayout} />
          ) : (
            ''
          )}
          {showFilterButton ? (
            <YumActivityFilter
              size={isNewLayout ? 'medium' : 'small'}
              default={this.state.defaultActivityFilter}
              current={activityFilter}
              countries={countries}
              divisions={divisions}
              activityView={activityView}
              groupView={groupView}
              isAdmin={isAdmin}
              country={country}
              divisionId={divisionId}
              setActivityFilter={this.setActivityFilter}
              setGroupView={this.setGroupView}
            />
          ) : (
            ''
          )}
          {isAdmin ? (
            <YumButton
              variant={isNewLayout ? 'text' : 'contained'}
              size={isNewLayout ? 'medium' : 'small'}
              style={
                isRtl
                  ? {
                      marginRight: '10px',
                    }
                  : {
                      marginLeft: '10px',
                    }
              }
              onClick={this.export}
            >
              {isNewLayout ? <IconDownload /> : <IconExport style={{ marginTop: -2 }} />}
              <Box
                display={{ xs: 'none', md: 'inline' }}
                style={{ marginLeft: isRtl ? 0 : 4, marginRight: isRtl ? 4 : 0 }}
              >{t`Export`}</Box>
            </YumButton>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
    )

    return (
      <>
        {/*{!isNewLayout && oldLayoutHeader}*/}
        {header}

        <div
          style={
            isNewLayout
              ? { padding: '0 10px 10px', paddingTop: !showTabs ? '10px' : 0, background: 'white', borderRadius: 8 }
              : {}
          }
        >
          {showTabs ? (
            <>
              <YumLeaderboardTabs value={activityView} onChange={this.handleTabChange}>
                {!hidePeopleTab ? <YumLeaderboardTab label={t`People`} value={ActivityView.INDIVIDUAL} /> : ''}
                {!hideGroupsTab && divisions && divisions.length ? (
                  <YumLeaderboardTab label={t`Teams`} value={ActivityView.GROUP} />
                ) : (
                  ''
                )}
                {!hideCountriesTab && countries && countries.length ? (
                  <YumLeaderboardTab label={t`Countries`} value={ActivityView.COUNTRY} />
                ) : (
                  ''
                )}
              </YumLeaderboardTabs>
            </>
          ) : (
            ''
          )}

          <Table
            data={visibleData}
            columns={columns}
            isLoading={!visibleData.length && activityProgressLoading}
            defaultSorted={[{ id: 'rank', desc: false }]}
            handleSortedChange={this.handleSortedChange}
            fetchMoreData={this.fetchMoreData(totalItems)}
            className="activity-list"
          />
          {data.length === 0 && !activityProgressLoading ? (
            <div className="user-activity user-activity--is-empty">{t`No matches found.`}</div>
          ) : (
            ''
          )}
        </div>
      </>
    )
  }
}
